import { render } from "./productsColorList.vue?vue&type=template&id=7786ba2f"
import script from "./productsColorList.vue?vue&type=script&lang=js"
export * from "./productsColorList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__